import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAppContext from "src/components/withAppContext";
import withAxios from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
import LoadingSpinner from "src/components/LoadingSpinner";
export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public readonly state = this.buildState({
            loader: false,
            getAllPlanData: [],
            getAllAddonData: [],
            subscriptionPlan: {},
            activeContainer: [],
            upgradeDetails: {}
          });
          public componentDidMount() {

            this.getUpgradeDetails()

          }
          public getUpgradeDetails = () => {
            const storedObject: string = localStorage.getItem("upgradeDetails") || '{}';  // Fallback to an empty object string
            const parsedObject = JSON?.parse(storedObject);
            if (Object.keys(parsedObject).length > 0) {
              this.setState({ upgradeDetails: parsedObject }, () => {
                this.setState({ subscriptionPlan: this.state?.upgradeDetails?.plan })
                this.getAllAddonHandler()
              })
            }
          }
         public planIDgets() {
            switch (this.state.subscriptionPlan.id) {
              case 2:
                return [1, 2, 3, 4]
              case 3:
                return [2, 3, 4]
              case 4:
                return [3, 4]
              case 5:
                return [4]
              default:
                return []
            }
          }
          public async getAllAddonHandler() {
            this.setState({ loader: true })
            const res: any = await this.buildGet(this, "payment/getAddonPlan")()
            if (res.status && res?.data?.length > 0) {
              console.log("res.data=======>", res.data)
              // const data = res.data.find((itm:any)=>this.state.subscriptionPlan.id===itm.id)
              // console.log("data=========>",data)
              const planAddon: any = []
              if (res?.data?.length > 0) {
                res.data.map((item: any) => {
                  if (this.planIDgets().includes(item.id)) {
                    planAddon.push(item)
                  }
                })
              }
              const data = planAddon.sort((a: any, b: any) => a.id - b.id);
              this.setState({ getAllAddonData: data })
              this.setState({ loader: false })
            } else {
              this.setState({ loader: false })
            }
            // this.setState({ user: res })
          }

          public toggleContainer(id: number) {
            // this.setState({ activeContainer: containerId === this.state.activeContainer ? null : containerId });
            this.setState((prevState: any) => {
              const { activeContainer } = prevState;

              if (activeContainer.length > 0 && activeContainer.includes(id)) {
                // If the id is already in the array, remove it
                return { activeContainer: activeContainer.filter((itemId: any) => itemId !== id) };
              } else {
                // If the id is not in the array, add it
                return { activeContainer: [...activeContainer, id] };
              }
            });
          }

          public NextHandler() {
            const tempData: any = []
            if (this.state.activeContainer?.length > 0) {
              this.state.getAllAddonData.map((item: any) => {
                if (this.state.activeContainer.includes(item.id)) {
                  tempData.push(item)
                }
              })
            }
            this.setState({ upgradeDetails: { ...this.state.upgradeDetails, addon: tempData, addonId: this.state.activeContainer } }, () => {
              localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));
              this.props.history.push(`/${this.props.school?.slug}/purchase-plan`)
            })
          }

          public render() {
            const {
              appContext: { user, baseUri },
              classes,
            } = this.props;
            console.log(user, classes, baseUri)
            const { activeContainer, subscriptionPlan } = this.state
            return (
<div>
              {this.state.loader &&<div className="loader-bg-color">
                <LoadingSpinner /></div>}
              <Page
                header={'Subscription Plans'}
                subtitle={''}
              >
                <div>
                  <div className="container">
                    <div className="content">
                      <div className="starter-plan">
                        <h3>You selected the <span>{subscriptionPlan?.title} plan.</span> <br />
                         {this.state.getAllAddonData.length > 0?" Would you like to add on some of our favorite plan enhancements?":""}
                        </h3>
                      </div>


                      <div className="row start-flex">
                        {
                          this.state.getAllAddonData.length > 0 && this.state.getAllAddonData?.map((item: any) => {
                            return (
                              <div className="col-lg-4" key={item?.id}>
                                <div
                                  className={`customize ${activeContainer?.includes(item?.id) ? 'active' : ''}`}
                                  onClick={ () => this.toggleContainer(item.id)}>
                                  <div className="customize-content">
                                    <h2>{item.title}</h2>
                                    <p className="custo-parag"><br/>{item?.description} </p>
                                  </div>
                                  <div className="custom-div">
                                    <button className="custom-btn">${item?.price}/{item?.payment_frequency_type}</button>
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        }



                        {/* 
                                                            <div className="col-lg-4">
                                                                  <div
                                                                        className={`customize ${activeContainer === 2 ? 'active' : ''}`}
                                                                        onClick={() => this.toggleContainer(2)}>
                                                                        <div className="customize-content">
                                                                              <h2>Parent Surveys</h2>
                                                                              <p className="custo-parag">Positive parent engagement is the key to long- term success in athletics. Partner with parents to harness the full potential of your athletic community. </p>

                                                                        </div>
                                                                        <div className="custom-div">
                                                                              <button className="custom-btn">$200/year</button>
                                                                        </div>
                                                                  </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                  <div
                                                                        className={`customize ${activeContainer === 3 ? 'active' : ''}`}
                                                                        onClick={() => this.toggleContainer(3)}>
                                                                        <div className="customize-content">
                                                                              <h2>Athletic Director Surveys</h2>
                                                                              <p className="custo-parag">Practice what you preach. Before you gather data about your coaches, invite them to provide feedback about your leadership as the Athletic Director.</p>

                                                                        </div>
                                                                        <div className="custom-div">
                                                                              <button className="custom-btn">$150/year</button>
                                                                        </div>
                                                                  </div>
                                                            </div> */}

                      </div>

                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                  <div className="button-next" style={{ marginRight: 20 }}>
                                                                        <button className="sign-btn" onClick={() => {
                                                                              this.props.history.goBack();
                                                                        }}><span className="next-span-btn">PREV</span></button>
                                                                  </div>
                                                                  <div className="button-next">
                                                                        <button className="sign-btn" onClick={() => {
                                                                              this.NextHandler()
                                                                        }}><span className="next-span-btn">NEXT</span></button>
                                                                  </div>
                                                            </div>
                      <div className="next-btn">

                        <button className="no-thanks" onClick={() => {
                          this.NextHandler()
                        }} ><span>NO THANKS</span></button>

                      </div>
                    </div>
                  </div>
                </div>
                
              </Page>
              </div>
            );
          }


        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/upgradeSubscription/addonPlan.tsx